import { GetterTree } from "vuex";
import { RootState } from "@/store/modules/general/types";
import { ARTICULO } from "../ventas/types";

type AuthGetterTree = GetterTree<ARTICULO, RootState>;

export const getters: AuthGetterTree = {
  
};
